import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import {
  FieldWrapper,
  useField,
  useFieldId,
  useFieldName,
  useFieldValue
} from '@morningtrain/react-fields'
import { useName } from '@morningtrain/react-resources'

function IntegerConverterField (props) {
  const name = useName(props.name)
  const fieldName = useFieldName(props.name)
  const [value, setValue] = useFieldValue(name, props.defaultValue)
  const id = useFieldId()

  return (
    <FieldWrapper id={id} name={name} label={props.label} required={props.required}>
      <input type='hidden' name={fieldName} value={value} />
      <input
        type='number'
        step={props.step}
        value={value / 100}
        onChange={e => setValue(Math.floor(e.target.value * 100))}
        placeholder={props.placeholder}
        disabled={props.disabled}
        readOnly={props.readOnly}
      />
    </FieldWrapper>
  )
}

IntegerConverterField.defaultProps = {
  ...useField.defaultProps,
  disabled: false,
  placeholder: '',
  readOnly: false,
  step: 0.01
}

IntegerConverterField.propTypes = {
  ...useField.propTypes,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  step: PropTypes.number
}

export default observer(IntegerConverterField)
